//
//
//

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    flag: {
      type: Boolean,
      required: false,
    },
    smallIcon: {
      type: Boolean,
      required: false,
    },
    mediumIcon: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    className: {
      type: String,
      required: false,
    },
    showIcon: {
      type: String,
      required: false,
    },
  },
  computed: {
    src() {
      const src = require(`~/assets/sprite/svg/${this.name}.svg?raw`)
      return src
    },
  },
}
